<div class="sidebar-brand-root border-b border-[var(--p-surface-200)] bg-[var(--p-primary-500)]">
  <div class="sidebar-brand-header" [class.sidebar-brand-header-collapsed]="collapsed">
    <button
      type="button"
      pRipple
      class="sidebar-brand-home motion-safe-transition border-0 bg-[var(--p-primary-500)] text-left hover:bg-[var(--p-primary-600)]"
      [class.sidebar-brand-home-collapsed]="collapsed"
      aria-label="Przejdź do strony głównej"
      (click)="homeRequested.emit()"
    >
      <span class="sidebar-brand-logo-box">
        <img
          src="assets/logo.png"
          alt="Portal Dewelopera"
          class="sidebar-brand-logo"
        />
      </span>

      @if (!collapsed) {
        <span class="sidebar-brand-title">
          Portal<br />Dewelopera
        </span>
      }
    </button>

    <button
      type="button"
      pRipple
      class="sidebar-collapse-toggle motion-safe-transition inline-flex items-center justify-center rounded-full border border-[var(--p-surface-200)] bg-[var(--p-surface-0)] text-[var(--p-text-muted-color)] shadow-sm hover:scale-105 hover:bg-[var(--p-primary-500)] hover:text-[var(--p-surface-0)]"
      [class.sidebar-collapse-toggle-collapsed]="collapsed"
      (click)="toggleRequested.emit()"
      aria-label="Przełącz sidebar"
    >
      <app-sidebar-icon [icon]="collapsed ? 'pi pi-chevron-right' : 'pi pi-chevron-left'" />
    </button>
  </div>
</div>
